<template>
  <section
    class="register-login-section"
    :style="viewportWidth > 860 ? { right: `${rightMargin}px` } : {}"
  >
    <div class="register-login-section__register">
      <h2 class="register-login-section__title">
        <span>New to Integrity?</span>
        Welcome!
      </h2>
      <a
        class="btn-custom primary"
        href="/register"
      >Register</a>
      <ul class="list-custom">
        <li>Free Next Business Day Delivery</li>
        <li>Dedicated And Knowledgeable Account Executives</li>
        <li>Local one stop shop for all things business</li>
      </ul>
    </div>
    <div class="register-login-section__login">
      <h2 class="register-login-section__title">
        Returning Customer?<br>
        Welcome Back!
      </h2>
      <button
        class="btn-custom primary"
        data-toggle="modal"
        data-target="#loginModal"
      >
        Login
      </button>
    </div>
  </section>
</template>

<script>
const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};

export default {
  name: 'RegisterLoginSection',
  data() {
    return {
      rightMargin: 0,
      viewportWidth: window.innerWidth,
    };
  },
  mounted() {
    this.calculateRightMargin();
    this.debouncedCalculate = debounce(this.calculateRightMargin, 250);
    window.addEventListener('resize', this.debouncedCalculate);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.debouncedCalculate);
  },
  methods: {
    calculateRightMargin() {
      this.viewportWidth = window.innerWidth;
      if (this.viewportWidth <= 860) return;

      const container = document.querySelector('.hero-splide .slider-navigation .container');
      if (container) {
        const containerRect = container.getBoundingClientRect();
        this.rightMargin = this.viewportWidth - containerRect.right + 10;
      }
    },
  },
};
</script>
